export default __webpack_public_path__ + "img/gfx_features_at_a_glance-ad0286cc5cb99fb222dbcf49a7463079.png";